import { Container, Stack } from "@mui/material";
import { useContext } from "react";
import { PageHeader, Spinner } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import useAccountLoyaltyData from "../api-hooks/useAccountLoyaltyData";
import CustomerSupportDiscountCard from "../components/CustomerSupportDiscountCard";
import CustomerSupportLoyaltyProgressBar from "../components/CustomerSupportLoyaltyProgressBar";
import ScoreDefinitionItem from "../components/ScoreDefinitionItem";

export default function ScorePage() {
    const { levels, accountLoyalty, isFetching } = useAccountLoyaltyData();

    const { openDialog } = useContext(DialogContext);

    if (isFetching) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="md">
            <PageHeader title="سطوح کاربری" />

            <CustomerSupportDiscountCard
                totalReferrals={accountLoyalty.totalReferrals}
            />

            <CustomerSupportLoyaltyProgressBar
                levels={levels}
                accountLoyalty={accountLoyalty}
            />

            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                justifyContent="space-between"
                sx={{ mt: 2 }}
            >
                {levels.map((i) => (
                    <ScoreDefinitionItem key={i.displayName} item={i} />
                ))}
            </Stack>
        </Container>
    );
}
